import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SpinnerIconProps {
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: string
}

export function SpinnerIcon({ size = 'md', className }: SpinnerIconProps) {
  const sizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  }

  return (
    <Loader2
      className={cn(
        'animate-spin text-muted-foreground',
        sizeClasses[size],
        className
      )}
    />
  )
}